import { Button, Grid, Typography } from '@mui/material'
import moment from 'moment'
import React, { useState } from 'react'
import NormalAbnormal from '../NormalAbnormal'
import CustomSelect from '../CustomSelect'
import AssessmentText from '../AssessmentText'
import AnDateTimePicker from '../../../../../components/DateTime/DateTimePicker'

const ENT = ({ submitModule }) => {
  const [moduleValues, setModuleValues] = useState({
    dateTime: moment(),
  })
  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} lg={6}>
        <Typography variant="title2">ENT Assessment</Typography>
      </Grid>
      <Grid item xs={12} lg={6}>
        <AnDateTimePicker
          date={moduleValues.dateTime}
          fullWidth
          size="small"
          onChange={(newDate) =>
            setModuleValues((prev) => ({ ...prev, dateTime: newDate }))
          }
        />
      </Grid>
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Left Ear"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Right Ear"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Hearing"
      />
      <CustomSelect
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        label="Epistaxis"
        options={['None', 'Left', 'Right', 'Both']}
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Nose"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Mouth"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Throat"
      />
      <NormalAbnormal
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
        fieldName="Lymph Nodes"
      />
      <AssessmentText
        moduleValues={moduleValues}
        setModuleValues={setModuleValues}
      />
      <Grid item xs={12}>
        <Button
          onClick={() => submitModule('ENT', moduleValues)}
          variant="contained"
          fullWidth
          color="success"
        >
          Submit
        </Button>
      </Grid>
    </Grid>
  )
}

export default ENT